import axios from "axios";

export function addNewCompetition(item, paymentScreenshotFile) {
  let formData = new FormData();
  formData.append("item", JSON.stringify(item));
  formData.append("paymentScreenshot", paymentScreenshotFile);

  return axios({
    url: `/designer/competitions`,
    headers: { "content-type": "multipart/form-data" },
    method: "post",
    data: formData,
    responseType: "json",
  }).then(function (response) {
    let data = response.data;
    return data;
  });
}
